import React from "react";
import { setLogout } from "@actions";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Accordion, Icon, Menu } from "semantic-ui-react";
import MainMenuItem from "../shared/MainMenuItem";

const MainMenu = (props) => {
  const { setLogout, menu, collapsed, onCollapse } = props;
  const history = useHistory();

  const onLogout = () => {
    setLogout().then(() => {
      history.push("/");
    });
  };

  const bottomMenu = menu.find((x) => x.code === "SETTINGS_AND_ADMIN");

  const menuOptions = menu.map(
    (item, itemIndex) =>
      item.code !== "SETTINGS_AND_ADMIN" && (
        <MainMenuItem props={props} item={item} itemIndex={itemIndex} />
      ),
  );

  return (
    <Accordion
      as={Menu}
      vertical
      inverted
      color="blue"
      icon={collapsed}
      fixed="left"
      style={{
        overflow: "auto",
        backgroundColor: "#5261FF",
        flexGrow: "1",
        display: "flex",
        scrollbarWidth: "thin",
      }}
    >
      <Menu.Item onClick={onCollapse}>
        {collapsed ? (
          <Icon name="bars" />
        ) : (
          <img src="logo-horizontal.png" alt="Logo" id="logo-horizontal" />
        )}
      </Menu.Item>
      {menuOptions}
      <div style={{ marginTop: "auto" }}>
        <MainMenuItem props={props} item={bottomMenu} itemIndex={0} />
        <Menu.Item style={{ width: "100%" }} name="spam" onClick={onLogout}>
          {!collapsed && <span>Log Out</span>}
          <Icon name="sign-out" />
        </Menu.Item>
      </div>
    </Accordion>
  );
};

export default connect(null, { setLogout })(MainMenu);
